const links = [{
  url: 'https://theophagyst.bandcamp.com',
  label: 'Follow me on Bandcamp',
  icon: 'mdi-bandcamp'
}, {
  url: 'https://www.bg-rock-archives.com/discography.php?band_id=1839',
  label: 'Profile on BG Rock Archives',
  icon: 'mdi-guitar-pick'
}, {
  url: 'https://facebook.com/theophagyst',
  label: 'Follow me on Facebook',
  icon: 'mdi-facebook'
}, {
  url: 'https://martinivanov.net',
  label: 'Blog',
  icon: 'mdi-book-open-page-variant'
}, {
  url: 'https://twitter.com/vuecidity',
  label: 'Follow me on Twitter',
  icon: 'mdi-twitter'
}, {
  url: 'https://www.linkedin.com/in/martin-krasimirov-ivanov/',
  label: 'Follow me on LinkedIn',
  icon: 'mdi-linkedin-box'
}]

export default links



// WEBPACK FOOTER //
// ./src/helpers/links.js